<template>
  <v-col v-show="$vuetify.breakpoint.mdAndUp" cols="4">
    <v-card rounded="lg">
      <v-card-title>{{
        $store.getters["patient/fullName"] || "N⁄A"
      }}</v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" class="d-flex">
            <span>Gender</span>
            <span class="ml-auto font-weight-bold">{{
              patient.gender || "N⁄A"
            }}</span>
          </v-col>
          <v-col cols="12" class="d-flex">
            <span>Marital Status</span>
            <span class="ml-auto font-weight-bold">{{
              patient.marital_status || "N⁄A"
            }}</span>
          </v-col>
          <v-col cols="12" class="d-flex">
            <span>Age</span>
            <span class="ml-auto font-weight-bold">{{
              patient.age || "N⁄A"
            }}</span>
          </v-col>
          <v-col cols="12" class="d-flex">
            <span>Birthdate</span>
            <span class="ml-auto font-weight-bold">{{
              patient.birthdate || "N⁄A"
            }}</span>
          </v-col>
          <v-col cols="12" class="d-flex">
            <span>Height</span>
            <span class="ml-auto font-weight-bold">{{
              patient.height || "N⁄A"
            }}</span>
          </v-col>
          <v-col cols="12" class="d-flex">
            <span>Weight</span>
            <span class="ml-auto font-weight-bold">{{
              patient.weight || "N⁄A"
            }}</span>
          </v-col>
          <v-col cols="12" class="d-flex">
            <span>BMI</span>
            <span class="ml-auto font-weight-bold">{{
              patient.bmi || "N⁄A"
            }}</span>
          </v-col>
          <v-col cols="12" class="d-flex">
            <span>Date measured</span>
            <span class="ml-auto font-weight-bold">{{
              patient.date_measured || "N⁄A"
            }}</span>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "MedicationProfileCard",
  props: ['patient'],
};
</script>
